{
  "chart": {
    "empty": {
      "description": "No data available for this period.",
      "title": "No data found"
    }
  },
  "date_picker": {
    "all_time": "All time",
    "confirm": "Confirm",
    "current_quarter": "Current Quarter",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Last {days} days",
    "last_n_months": "Last {months} months",
    "last_quarter": "Last Quarter",
    "last_year": "Last Year",
    "lifetime": "Lifetime",
    "this_year": "This Year",
    "today": "Today"
  },
  "document_viewer": {
    "sidebar_heading": "Content overview"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Write something",
    "placeholder_with_options": "Write or type '/' for options"
  },
  "error": {
    "title": "An error occurred."
  },
  "factor_indicator": {
    "average": "Average",
    "bad": "Critical",
    "excellent": "Excellent",
    "good": "Good"
  },
  "gauge_chart": {
    "empty": {
      "title": "No data available",
      "tooltip": "Your resilience score is being calculated"
    }
  },
  "locale": {
    "current": "English",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Continue with {provider}"
  },
  "search": {
    "no_options": "No options available.",
    "no_results": "No results found.",
    "placeholder": "Search..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Close preview",
      "open": "Expand preview"
    }
  },
  "video_player": {
    "captions": "Captions",
    "captions_off": "Off",
    "normal_speed": "Normal",
    "playback_speed": "Playback speed"
  }
}
